













































































































































































































import {
  getDefaultPagination,
  getDefaultPatientOptions,
} from "@/utils/store-util";
import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { paramedicPatientsModule } from "@/store/modules/paramedicPatients";
import { getAllPatientsByAccount } from "@/api/accountListService";

@Component
export default class ParamedicCharge extends Vue {
  public patientOptions = getDefaultPatientOptions();
  private lastSearch = "";
  private a_patientOptions = getDefaultPatientOptions();
  private a_lastSearch = "";
  public search = "";
  public a_search = "";
  public headers = [
    {
      text: "名稱",
      left: true,
      sortable: false,
      value: "name",
    },
    { text: "身份證字號", sortable: false, value: "iid" },
    { text: "性別", sortable: false, value: "gender" },
    { text: "年齡", sortable: false, value: "age" },
    { text: "生日", sortable: false, value: "birthday" },
    { text: "電話", sortable: false, value: "phone" },
    { text: "信箱", sortable: false, value: "email" },
  ];
  public modify_items = [];
  public add_list = "";

  public remove_dialog = false;
  public add_dialog = false;
  public add_dialog2 = false;
  public copiedSnackbar = false;
  public copyingIids = false;
  public dialogTitle = "";
  public account = {
    name: "",
    uuid: "",
  };
  get loading() {
    return paramedicPatientsModule.loading;
  }

  get aLoading() {
    return paramedicPatientsModule.aLoading;
  }

  get responsiblePatients() {
    return paramedicPatientsModule.responsiblePatients;
  }

  get totalResponsiblePatients() {
    return paramedicPatientsModule.totalResponsiblePatients;
  }

  get pagination() {
    return paramedicPatientsModule.pagination;
  }

  set pagination(pagination) {
    paramedicPatientsModule.setPagination(pagination);
  }

  get needToAddPatients() {
    return paramedicPatientsModule.needToAddPatients;
  }

  get aPagination() {
    return paramedicPatientsModule.aPagination;
  }

  set aPagination(aPagination) {
    paramedicPatientsModule.setaPagination(aPagination);
  }

  async copyAllIids() {
    this.copyingIids = true;
    try {
      const patients = await getAllPatientsByAccount(this.account.uuid);
      const iids = patients.map((p) => p.iid).join(",");
      await navigator.clipboard.writeText(iids);
      this.copiedSnackbar = true;
    } finally {
      this.copyingIids = false;
    }
  }

  async created() {
    this.account.name = localStorage.getItem("accountName");
    this.account.uuid = this.$router.currentRoute.params.id;

    this.updateTable();
  }

  async updateTable() {
    this.pagination = getDefaultPagination();
    await this.updateTableData();
    await this.justNeedAdd();
  }

  async justNeedAdd() {
    if (!this.aLoading) {
      if (this.a_patientOptions.q !== this.a_lastSearch) {
        this.a_patientOptions.page = 1;
        this.a_lastSearch = this.a_patientOptions.q;
      }
    }
    const param = {
      uuid: this.account.uuid,
      options: this.a_patientOptions,
    };
    await paramedicPatientsModule.needToAddPatientsList(param);
  }

  async updateTableData() {
    if (!this.loading) {
      if (this.patientOptions.q !== this.lastSearch) {
        this.patientOptions.page = 1;
        this.lastSearch = this.patientOptions.q;
      }
    }
    const param = {
      uuid: this.account.uuid,
      options: this.patientOptions,
    };
    await paramedicPatientsModule.responsiblePatientsList(param);
  }

  removeDialog() {
    this.remove_dialog = true;
    this.dialogTitle = "移除個案";
  }

  addDialog() {
    this.modify_items = [];
    this.add_list = "";
    this.add_dialog = true;
    this.dialogTitle = "新增個案";
  }

  addDialog2() {
    this.modify_items = [];
    this.add_list = "";
    this.add_dialog2 = true;
    this.dialogTitle = "新增個案";
  }

  showDialog(title) {
    this.remove_dialog = true;
    this.dialogTitle = title;
  }

  async modifyPatient() {
    const params = {
      add: [],
      remove: [],
    };
    if (this.dialogTitle === "新增個案") {
      const add_id = [];

      if (this.add_list.length > 0) {
        const add_list = this.add_list.split(",");
        add_list.forEach(function (item) {
          add_id.push(item);
        });
      }
      if (this.modify_items.length > 0) {
        for (const item of this.modify_items) {
          add_id.push(
            await paramedicPatientsModule.modifyPatientsId(item.uuid)
          );
        }
      }
      params.add = add_id;
    } else {
      const remove_id = [];
      if (this.modify_items.length > 0) {
        for (const item of this.modify_items) {
          remove_id.push(
            await paramedicPatientsModule.modifyResponsible(item.uuid)
          );
          params.remove = remove_id;
        }
      }
    }

    const data = {
      uuid: this.account.uuid,
      params: params,
    };

    await paramedicPatientsModule.addPatientsToAccount(data);
  }

  close() {
    this.remove_dialog = false;
    this.add_dialog = false;
    this.add_dialog2 = false;
    this.add_list = "";
    this.modify_items = [];
  }

  close2() {
    this.add_dialog2 = false;
    this.add_list = "";
    this.modify_items = [];
  }

  public async save() {
    await this.modifyPatient();
    this.close();
    this.close2();
    await this.updateTable();
  }

  @Watch("patientOptions.q")
  watchSearch(newVal, oldVal) {
    if (newVal != oldVal && newVal == "") {
      this.updateTableData();
    }
  }

  @Watch("a_patientOptions.q")
  watchASearch(newVal, oldVal) {
    if (newVal != oldVal && newVal == "") {
      this.justNeedAdd();
    }
  }
}
